import React, { useCallback } from 'react';
import { SearchButton, SearchInputWrapper, StyledInput } from './search-styles';

interface Props {
  onChange: (value: string) => void;
}

export function SearchInput(props: Props) {
  const { onChange } = props;

  const handleOnChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(String(event.target.value).trim());
    },
    [onChange]
  );

  return (
    <SearchInputWrapper>
      <SearchButton />
      <StyledInput
        autoFocus
        data-cy="universal-search-text-input"
        placeholder="Enter Address, APN, License, or Listing id"
        onChange={handleOnChange}
      />
    </SearchInputWrapper>
  );
}
